import React from "react";

interface MiniHeroProps {
  image: string;
  text: string;
}

const MiniHero: React.FC<MiniHeroProps> = ({ image, text }) => {
  return (
    <div className="relative w-full h-[40vh]">
      {/* Hero Image */}
      <img
        className="w-full h-full object-cover"
        src={image}
        alt="Hero Banner"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40">
        {/* Text Container */}
        <div className="container mx-auto h-full flex items-end">
          <div className="w-full text-left pb-12 md:pl-64 pl-8">
            <h2
              className="text-6xl font-bold text-white"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              {text}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniHero;
